<template>
  <v-card :flat="isModal ? true : false">
    <v-card-title class="pb-0">
      <h1 class="headline">
        Редактирование Области
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout column>
          <v-flex xs12>
            <v-layout row>
              <v-flex
                xs4
                class="mt-3"
              >
                <TitleTextField
                  v-model="entity.title"
                  class="mx-2 mt-3"
                  :required="true"
                  :input-language="inputLanguage"
                  :rules="[
                    v => !!v || 'Наименование обязательно к заполнению',
                    v =>
                      v.length >= 3 ||
                      'Наименование должно содержать не менее 3-х символов'
                  ]"
                  label="Наименование*"
                  @input="entityChange"
                />
              </v-flex>
              <v-flex xs4>
                <CountryReference
                  v-model="entity.country"
                  :rules="[v => !!v || '']"
                  :clearable="true"
                  label="Страна*"
                  class="mx-2 mt-3"
                  @input="countryChange"
                />
              </v-flex>
              <v-flex xs4>
                <RegionReference
                  v-model="entity.region"
                  :rules="[v => !!v || '']"
                  :clearable="true"
                  label="Регион*"
                  :country-id="entity.country ? entity.country.id : 0"
                  class="mx-2 mt-3"
                  @input="regionChanged"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-btn
            small
            color="primary"
            :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
            class="mt-3 mr-2"
            @click="submit(false)"
          >
            Сохранить
          </v-btn>
          <v-btn
            small
            class="mt-3"
            @click="cancel"
          >
            Отмена
          </v-btn>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import mixin from "../../mixins/confirm-cancel-changes.js";
import CountryReference from "../../components/references/CountryReference.vue";
import RegionReference from "../../components/references/RegionReference.vue";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import * as districtsApi from "../../backend/districtsApi.js";
import TitleTextField from "../../components/TitleTextField.vue";

export default {
  components: {
    CountryReference,
    RegionReference,
    TitleTextField,
  },
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      entity: {
        id: 0,
        title: "",
        country: null,
        region: null,
      },
      entityRestored: false,
      resource: "districts",
      isValid: false,
      isChanged: false,
      loading: false,
    };
  },
  computed: {
    inputLanguage() {
      return this.entity.country ? this.entity.country.inputLanguage : "";
    },
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    isConfirmed() {
      if (Object.prototype.hasOwnProperty.call(this.entity, "isConfirmed")) {
        return this.entity.isConfirmed;
      }
    },
  },
  mounted() {
    NestedEditorsEventBus.$emit("modal-editor-mounted");
  },
  methods: {
    async getData() {
      this.loading = true;
      this.entity = await districtsApi.getDistrict(this.resource, this.id);
      this.entityRestored = true;
      this.loading = false;
    },
    entityChange() {
      if (!this.entityRestored && !this.isModal) {
        return;
      }

      this.isChanged = true;
    },
    async submit() {
      const entity = {
        id: this.entity.id,
        title: this.entity.title,
        countryId: this.entity.country.id,
        regionId: this.entity.region.id,
        isRemoved: this.entity.isRemoved,
        isConfirmed: this.entity.isConfirmed,
      };
      this.loading = true;
      const res = await districtsApi.createDistrict(this.resource, entity);
      this.showInfo("Область добавлена");
      this.entity.id = res.data;
      NestedEditorsEventBus.$emit("create", this.entity.id);
      this.loading = false;
    },
  },
  cancel() {
    NestedEditorsEventBus.$emit("close");
  },
  async saveAndClose() {
    await this.submit();
  },
  regionChanged(payload) {
    this.entity.country = null;
    if (payload && payload.country) {
      this.entity.country = payload.country;
    }
    this.entityChange();
  },
  countryChange(payload) {
    this.entity.region = null;
    if (payload && payload.region) {
      this.entity.region = payload.region;
    }
    this.entityChange();
  },
  resetLoaders() {
    this.loading = false;
  },
};
</script>
